import React from 'react';
import { X, Command } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './AlphaModal.css';

interface KeyboardShortcutsModalProps {
  onClose: () => void;
}

const KeyboardShortcutsModal: React.FC<KeyboardShortcutsModalProps> = ({
  onClose,
}) => {
  const { t } = useTranslation();

  const shortcuts = [
    { name: t('alpha.shortcuts.closeChatbot'), keys: ['Esc'] },
    { name: t('alpha.shortcuts.openCloseChatbot'), keys: ['Ctrl', 'K'] },
    { name: t('alpha.shortcuts.sendMessage'), keys: ['Enter'] },
    { name: t('alpha.shortcuts.restartConversation'), keys: ['Ctrl', 'R'] },
    { name: t('alpha.shortcuts.toggleHistory'), keys: ['Ctrl', 'H'] },
  ];

  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/30">
      <div className="w-[400px] rounded-lg bg-surface shadow-lg overflow-hidden">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center">
            <Command size={20} className="mr-2 text-primary" />
            <h2 className="keyboard-shortcuts-header">{t('alpha.shortcuts.title')}</h2>
          </div>
          <button onClick={onClose}>
            <X size={24} className="text-text-muted" />
          </button>
        </div>
        <div className="p-6">
          <ul>
            {shortcuts.map((shortcut) => (
              <li
                key={shortcut.name}
                className="flex items-center justify-between py-3 border-b border-border"
              >
                <span>{shortcut.name}</span>
                <div className="flex items-center space-x-2">
                  {shortcut.keys.map((key) => (
                    <kbd key={key} className="key-style">
                      {key}
                    </kbd>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default KeyboardShortcutsModal;